import { Field, Form, Formik, useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FiChevronUp,
  FiChevronDown,
  FiCheckCircle,
  FiAlertCircle,
} from "react-icons/fi";
import { questionsData } from "src/core/statics/questions-school-leader/questions-school-leader";
import { initialValues } from "src/core/statics/questions-school-leader/questions-school-leader-data";
import { InitialValuesType } from "src/core/types/questions-school-leader-type";
import { schoolLeaderQuestions } from "./validation/school-leader-questions-validation";

interface IProps {
  formSubmitted: boolean;
  setFormSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
}
function QuestionsForSchoolLeaderComponent(props: IProps) {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState<number[]>([]);
  const handleOpen = (value: number) => {
    let UpdatedOpen = [];
    if (isOpen.includes(value)) {
      UpdatedOpen = isOpen.filter((item) => item !== value);
      setIsOpen(UpdatedOpen);
    } else {
      UpdatedOpen = [...isOpen];
      UpdatedOpen.push(value);
      setIsOpen(UpdatedOpen);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async () => {
      props.setFormSubmitted(true);
    },
    validationSchema: schoolLeaderQuestions,
  });
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col w-[1000px] tablet:w-[600px] mobile:w-[336px]"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={schoolLeaderQuestions}
        onSubmit={() => formik.submitForm()}
      >
        <Form
          className="flex flex-col mobile:mx-2"
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          {Object.keys(formik.touched).some(
            (key) =>
              formik.touched[key as keyof InitialValuesType] &&
              formik.errors[key as keyof InitialValuesType]
          ) && (
            <div className="flex items-center gap-1.5 mb-3">
              <FiAlertCircle size={24} className="text-secondary-50" />
              <p className="text-xl mobile:text-sm font-arMedium text-secondary-50 pt-2">
                {t("schoolLeaderQuestoons.validation.pleaseAnswerAllQuestion")}
              </p>
            </div>
          )}
          {questionsData.map((item, index) => (
            <div key={index}>
              <div
                className={`flex justify-between cursor-pointer items-center py-3 px-3.5 bg-mint-500 ${
                  isOpen.includes(index) ? "border-b border-mint-600" : ""
                } ${index === 0 ? "rounded-t-xl" : ""} `}
                onClick={() => handleOpen(index)}
              >
                <div className="font-arMedium text-zinc50 text-xl">
                  {i18n.language === "ar" ? item.title : item.titleEn}
                </div>
                <div className="flex flex-row gap-4 mobile:gap-2">
                  {formik.values[item.name as keyof InitialValuesType]
                    ?.length !== 0 && (
                    <FiCheckCircle size={24} className="text-zinc-50" />
                  )}
                  {formik.touched[item.name as keyof InitialValuesType] &&
                    formik.errors[item.name as keyof InitialValuesType] && (
                      <FiAlertCircle className="text-secondary-50" size={24} />
                    )}
                  {!isOpen.includes(index) ? (
                    <FiChevronUp size={24} className="text-zinc50" />
                  ) : (
                    <FiChevronDown size={24} className="text-zinc50" />
                  )}
                </div>
              </div>
              {!isOpen.includes(index) && (
                <div
                  className={`bg-zinc50 shadow ${
                    index === questionsData.length - 1 ? "rounded-b-xl" : ""
                  }`}
                  key={index}
                >
                  {(i18n.language === "ar"
                    ? item.contents
                    : item.contentsEn
                  ).map((element, index) => (
                    <div className="flex gap-2 pl-3 pr-6 py-3" key={index}>
                      <Field
                        type="checkbox"
                        id={`${item.name}-${index}`}
                        name={item.name}
                        value={element}
                        checked={formik.values[
                          item.name as keyof InitialValuesType
                        ]?.includes(element)}
                        onChange={formik.handleChange}
                      ></Field>
                      <div
                        className={`font-arMedium text-xl mobile:text-sm ${
                          i18n.language === "ar" ? "text-right" : "text-left"
                        } text-zinc500 w-full`}
                      >
                        {element}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
          <div className="flex flex-col items-center">
            <button
              type="submit"
              className="w-[345px] mobile:w-[336px] h-14 px-4 py-2 bg-mint-500 text-white text-xl font-arMedium rounded-xl mt-11"
            >
              {t("app.shared.register")}
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default QuestionsForSchoolLeaderComponent;
